"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class DeviceApi {
    constructor(api) {
        this.api = api;
    }
    /**
     * 回報 Device 最後活著的時間，後端會根據收到 request 的時間寫入 lastHealthTime
     */
    updateTTL(deviceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/device/${deviceId}/ttl`;
            const response = yield this.api.axiosGo.put(endpoint);
            return response.data;
        });
    }
    /**
     * 修改 Device 內容，但目前只有 CA 使用 isMaster 和 lastHealthTime 這兩個欄位
     */
    updateDevice(deviceId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/device/${deviceId}`;
            const response = yield this.api.axiosGo.put(endpoint, data);
            return response.data;
        });
    }
}
exports.default = DeviceApi;
//# sourceMappingURL=Device.js.map